{
  "customer-register-form": {
    "text": {
      "accept": "Souhlasím se ",
      "agb": "Všeobecné obchodní podmínky",
      "required": "*) vyžadováno"
    }
  }
}
